import { cloneDeep } from "lodash-es";
export default relaxLabelAngles;
function normalizeAngle(angle) {
  if (angle > Math.PI * 2) {
    return angle - Math.PI * 2;
  } else if (angle < 0) {
    return angle + Math.PI * 2;
  } else {
    return angle;
  }
}
function relaxLabelAngles(_labelPoints, spacing, maxradius) {
  const maxLabelsPerQuadrant = Math.floor(maxradius / spacing) + 4;
  let labels = cloneDeep(_labelPoints);
  if (labels.length > maxLabelsPerQuadrant * 4) {
    labels = combineLabels(labels, maxLabelsPerQuadrant * 4);
  }
  const totalLength = Math.PI * 2;
  let rightTopLabels = [];
  let rightBottomLabels = [];
  let leftTopLabels = [];
  let leftBottomLabels = [];
  let label;
  for (let i = 0; i < labels.length; i++) {
    label = labels[i];
    label.angle = normalizeAngle(label.angle);
    const labelCenter = label.angle;
    if (labelCenter <= totalLength / 4) {
      rightTopLabels.push(label);
    } else if (labelCenter > totalLength / 4 && labelCenter <= totalLength / 2) {
      rightBottomLabels.push(label);
    } else if (labelCenter > totalLength / 2 && labelCenter <= 3 * totalLength / 4) {
      leftBottomLabels.push(label);
    } else {
      leftTopLabels.push(label);
    }
  }
  function repositionAndGroupLabels(labels2) {
    const extraSpaces = Math.max(maxLabelsPerQuadrant - labels2.length, 0);
    let lastLabelYPosition = 0 - spacing / 2;
    let lastlabel;
    return labels2.map(function(label2, idx) {
      if (Math.abs(lastLabelYPosition) > maxradius + 80) {
        lastlabel.labelAndSublabels.push(label2);
        lastlabel.labelIds[label2.id] = true;
        return false;
      }
      lastlabel = label2;
      if (label2.y < lastLabelYPosition) {
        const naturalSlot = Math.floor(Math.abs(label2.y / spacing));
        if (naturalSlot > extraSpaces) {
          if (idx < naturalSlot && extraSpaces > 0) {
            lastLabelYPosition = label2.y;
          }
          label2.y = lastLabelYPosition;
        }
        let x = Math.sqrt(Math.pow(maxradius, 2) - Math.pow(label2.y, 2));
        if (!x) x = 0;
        label2.x = label2.x > 0 ? x : -x;
        lastLabelYPosition = label2.y - spacing;
      } else {
        label2.y = lastLabelYPosition;
        lastLabelYPosition = label2.y - spacing;
      }
      return label2;
    }).filter(function(l) {
      return !!l;
    });
  }
  let labelsToReturn = [];
  rightTopLabels = rightTopLabels.sort(sortLabelsByAngleReverse);
  labelsToReturn = labelsToReturn.concat(
    repositionAndGroupLabels(rightTopLabels, true)
  );
  rightBottomLabels = rightBottomLabels.sort(sortLabelsByAngle);
  labelsToReturn = labelsToReturn.concat(
    flipLabelYs(repositionAndGroupLabels(flipLabelYs(rightBottomLabels)))
  );
  leftBottomLabels = leftBottomLabels.sort(sortLabelsByAngleReverse);
  labelsToReturn = labelsToReturn.concat(
    flipLabelYs(repositionAndGroupLabels(flipLabelYs(leftBottomLabels)))
  );
  leftTopLabels = leftTopLabels.sort(sortLabelsByAngle);
  labelsToReturn = labelsToReturn.concat(
    repositionAndGroupLabels(leftTopLabels)
  );
  return labelsToReturn;
  function flipLabelYs(labels2) {
    return labels2.map(function(label2) {
      label2.y = -label2.y;
      return label2;
    });
  }
}
function sortLabelsByAngle(a, b) {
  return a.angle - b.angle;
}
function sortLabelsByAngleReverse(b, a) {
  return a.angle - b.angle;
}
function combineLabels(labels, numberOfBuckets) {
  const buckets = {};
  Object.keys(labels).forEach(function(key) {
    const label = labels[key];
    const bucket = Math.floor(
      label.annotationCenterAngle / 6.29 * numberOfBuckets
    );
    if (!buckets[bucket]) {
      buckets[bucket] = label;
    } else {
      buckets[bucket].labelAndSublabels.push(label);
      buckets[bucket].labelIds[label.id] = true;
    }
  });
  const combinedLabels = Object.keys(buckets).map(function(key) {
    return buckets[key];
  });
  return combinedLabels;
}
